module.exports = {
    K: {de: 'Krone unverblendet', en: 'Full Anatomic Crown'},
    KV: {de: 'Krone, vestibulär verblendet', en: 'Crown, vestibular veneer'},
    KM: {de: 'Krone, vollverblendet', en: 'Crown, full veneer'},
    B: {de: 'Brückenglied unverblendet', en: 'Full Anatomic Bridge Part'},
    BV: {de: 'Brückenglied, vestibulär verblendet', en: 'Bridge Part, vestibular veneer'},
    BM: {de: 'Brückenglied, vollverblendet', en: 'Bridge Part, full veneer'},
    V: {de: 'Veneer', en: 'Veneer'},
    PK: {de: 'Teilkrone / Inlay / Onlay', en: 'Partial Crown / Inlay / Onlay'},
    T1: {de: 'Teleskop primär', en: 'Primary Telescope'},
    T: {de: 'Teleskop sek. unverblendet', en: 'Secondary Telescope'},
    T2V: {de: 'Teleskop sek. vest. verbl.', en: 'Secondary Telescope, vestibular veneer'},
    T2M: {de: 'Teleskop sek. vollverbl.', en: 'Secondary Telescope, full veneer'},
    T2: {de: 'Teleskop primäre und Teleskop sek. unverblendet', en: 'Primary and Secondary Telescope'},
    TV: {de: 'Teleskop primär und Teleskop sek. vest. verbl.', en: 'Primary and Secondary Telescope, vestibular veneer'},
    TM: {de: 'Teleskop primär und Teleskop sek. vollverbl.', en: 'Primary and Secondary Telescope, full veneer'},
    ST:	{de: 'Impla-Teleskop primär und Teleskop sek. unverblendet', en: 'Implant Telescope primary and secondary'},
    STV: {de: 'Impla-Teleskop primär und Teleskop sek. vest. verbl.', en: 'Implant Telescope primary and secondary, vestibular veneer'},
    STM: {de: 'Impla-Teleskop primär und Teleskop sek. vollverbl.', en: 'Implant Telescope primary and secondary, full veneer'},
    I: {de: 'Implantat', en: 'Implant'},
    EO: {de: 'Zu ersetzender Zahn mit Stegverbindung', en: 'Tooth to replace with bar connector'},
    STE: {de: 'Stegüberwurf', en: 'Bar coating'},
    MOG: {de: 'Modellguss', en: 'Model casting / Partial denture'},
    R: {de: 'Retention / Klebeverbinder', en: 'Retention / Adhesive connector'},
    O: {de: 'Geschiebe / Steg', en: 'Attachment / Bar'},
    H: {de: 'Halteelement', en: 'Retention element'},
    TER: {de: 'Tertiärkonstruktion', en: 'Tertiary construction'},
    S: {de: 'Schiene', en: 'Splint'},
    E: {de: 'Zu ersetzender Zahn', en: 'Tooth to replace'},
    KO2: {de: 'Krone unverblendet Teilungsgeschiebe', en: 'Crown and div. attachment'},
    KVO2: {de: 'Krone vest. verbl. Teilungsgeschiebe', en: 'Crown vestibular veneer div. attachment'},
    KMO2: {de: 'Krone vollverbl. Teilungsgeschiebe', en: 'Crown full veneer div. attachment'},
    KO: {de: 'Krone unverblendet Geschiebe', en: 'Crown Attachment'},
    KVO: {de: 'Krone vest. verbl. Geschiebe', en: 'Crown vestibular veneer attachment'},
    KMO: {de: 'Krone vollverbl. Geschiebe', en: 'Crown full veneer attachment'},
    KH: {de: 'Krone unverblendet Halteelement', en: 'Crown retention element'},
    KVH: {de: 'Krone vest. verbl. Halteelement', en: 'Crown vestibular veneer retention element'},
    KMH: {de: 'Krone vollverbl. Halteelement', en: 'Crown full veneer retention element'},
    RET: {de: 'Retainer', en: 'Retainer'},
    STI: {de: 'Stiftaufbau', en: 'Pin superstructure'},
    L: {de: 'Löffel', en: 'Spoon'}
};